<script>
    import moment from 'moment';
    import {Line} from "vue-chartjs";
    import DashboardService from "../../../services/Dashboard.service";
    import {alertResponseError} from "../../../helpers/general";

    export default {
        extends: Line,
        data() {
            return {
                labels: [],
                names: [],
                borderColors: [
                    "rgba(255, 0, 0, 0.25)",
                    "rgba(204, 51, 255, 0.25)",
                    "rgba(0, 102, 255, 0.25)",
                    "rgba(40, 120, 56, 0.25)",
                    "rgba(22, 220, 30, 0.25)",
                    "rgba(218, 159, 0, 0.25)",
                    "rgba(255, 231, 0, 0.25)"
                ]
            }
        },
        created() {
            this.getModelTrainHistoryAccuracy();
        },
        methods: {
            getModelTrainHistoryAccuracy() {
                return DashboardService.getModelTrainHistoryAccuracy().then((response) => {
                    if (response.data.success) {
                        if (response.data.data && response.data.data.length > 0) {
                            this.names = response.data.data.map((item) => {
                                return item.name;
                            });
                            const data = response.data.data.map((item) => {
                                return Object.values(item.accuracy_by_date);
                            });
                            let modelTrains = [];
                            //  { labels: ["2020-03-21", "2020-03-24", "2020-03-26", "2020-03-29", "2020-03-30"] data: [82, 96, 96, 99, 96] }
                            for(let i = 0; i < data.length; ++i) {
                                modelTrains.push( 
                                    { 
                                        labels: data[i].map((item) => {
                                            return item.date;
                                        }),
                                        data: data[i].map((item) => {
                                            return item.accuracy;
                                        }),
                                    }
                                );
                            }
                            let labels = [];
                            for(let i = 0; i < modelTrains.length; ++i) {
                                labels = labels.concat(modelTrains[i].labels).sort();
                            }
                            if (labels.length <= 0) {
                                return this.$emit('isShow', false);
                            } else {
                                this.labels = [...new Set(labels)];
                                return this.showChart(this.transformData(modelTrains));
                            }
                        } else {
                            return this.$emit('isShow', false);
                        }
                    }
                }).catch((error) => {
                    alertResponseError(error);
                })
            },
            transformData(data) {
                const graphLabels = this.labels;
                const arrLabels  = data.map((items) => {
                    return items.labels;
                });
                const arrAccuracy = data.map((items) => {
                    return items.data;
                });
                let sameOf2Arrays= [];
                for (let i = 0; i< arrLabels.length; ++i) {
                    let index = [];
                    arrLabels[i].forEach((item) => {
                        index.push(graphLabels.indexOf(item));
                    });
                    sameOf2Arrays.push(index);
                }
                sameOf2Arrays.forEach((item, index) => {
                    for (let i = 0; i < graphLabels.length; i++) {
                        if (i !== item[i] || item[i] === undefined) {
                            this.insert(item, i, i);
                            this.insert(arrAccuracy[index], i, null)
                        }
                    }
                });
                return arrAccuracy;
            },
            insert(arr, index, newItem) {
                arr.splice(index, 0, newItem);
                return arr.join();
            },
            showChart(data) {
                const labels = this.labels;
                let graphDatasets = data.map((item, index) => {
                    return {
                        label: this.names[index] ? this.names[index] : this.$t('dashboard.ai_name_default'),
                        data: item,
                        backgroundColor: "transparent",
                        borderColor: this.borderColors[index % this.borderColors.length],
                        pointBackgroundColor: this.borderColors[index % this.borderColors.length]
                    }
                });
                this.renderChart(
                    {
                        labels: labels,
                        datasets: graphDatasets,
                    },
                    {
                        responsive: true,
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true,
                                }
                            }],
                            xAxes: [{
                                ticks: {
                                    callback: function(value) { 
                                        return moment(value).format("MM-DD");
                                    },
                                },
                            }]
                        },
                        maintainAspectRatio: false,
                        spanGaps: true,
                        title: {
                            display: true,
                        }
                    }
                );
            }
        }
    };
</script>
